import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Inventory from './pages/Inventory';
import ProductDetails from './pages/ProductDetails';
import Login from './pages/Login';
import Dashboard from './pages/Dashbord';
import Navbar from './components/Navbar';
import AddProduct from './pages/AddProduct';
import SearchExpert from './pages/SearchExpert'
import DeliveryNote from './pages/DeliveryNote';
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('isLogged') === 'true'
  );

  return (
    <Router>
      <div className="app-container">
        {/* On passe setIsAuthenticated à la Navbar pour le futur Logout */}
        {isAuthenticated && <Navbar setIsAuthenticated={setIsAuthenticated} />}

        <div className="main-content">
          <Routes>
            <Route path="/login" element={
              !isAuthenticated ? <Login setAuth={setIsAuthenticated} /> : <Navigate to="/dashboard" />
            } />

            {/* Route Dashboard ajoutée */}
            <Route path="/search" element={
              isAuthenticated ? <SearchExpert /> : <Navigate to="/login" />
            } />
            <Route path="/dashboard" element={
              isAuthenticated ? <Dashboard /> : <Navigate to="/login" />
            } />
            <Route path="/add-product" element={
              isAuthenticated ? <AddProduct /> : <Navigate to="/login" />
            } />
            <Route path="/delivery-note" element={
              isAuthenticated ? <DeliveryNote /> : <Navigate to="/login" />
            } />
            <Route path="/inventory" element={
              isAuthenticated ? <Inventory /> : <Navigate to="/login" />
            } />

            <Route path="/product/:id" element={
              isAuthenticated ? <ProductDetails /> : <Navigate to="/login" />
            } />

            {/* Redirection par défaut vers le Dashboard si connecté */}
            <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
